import { TrackMediaEventParams } from "redmond";
import axios from "axios";

import { mcLeanAxiosInstance } from "../../components/AxiosInterceptors";
import { createResponseErrorLog } from "../../components/Logger";
import { config } from "../config";
import { htsMediaApiPrefix } from "../paths";

const END_POINT: string = `${htsMediaApiPrefix}/track`;
const OFFER_NAME_TRACKING_DATA = "OfferNameTrackingData";

export const trackMediaEvent = async (
  params: TrackMediaEventParams
): Promise<boolean> => {
  const { eventType, trackingProperties, placement } = params;

  const request = {
    events: [
      {
        eventType: { EventType: eventType },
        trackingData: {
          TrackingData: OFFER_NAME_TRACKING_DATA,
          trackingProperties,
          placement,
        },
        occurredAt: new Date().toISOString(),
      },
    ],
  };

  try {
    const res = await mcLeanAxiosInstance.post(END_POINT, request, {
      baseURL: config.baseURL,
    });

    return res.data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      createResponseErrorLog(e);
    }
    return false;
  }
};
